import React from "react";
import { Link } from "react-router-dom";

const HomePage = () => {
  return (
    <section className="min-h-screen flex flex-col bg-gradient-to-br from-gray-50 via-white to-gray-50">
      {/* Header */}
      <header className="w-full px-6 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="/static/images/seekho-logo.png"
            alt="Seekho AMS"
            className="h-10 w-10"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
          <span className="text-2xl font-bold bg-gradient-to-r from-[#5E30BF] to-[#AF30BF] bg-clip-text text-transparent">
            Seekho AMS
          </span>
        </div>
        <Link
          to="/login"
          className="px-5 py-2.5 rounded-xl text-white font-medium bg-gradient-to-r from-[#5E30BF] to-[#AF30BF] hover:shadow-lg hover:shadow-primaryPurple/30 transition-all"
        >
          Sign in
        </Link>
      </header>

      {/* Hero */}
      <main className="flex-grow flex items-center justify-center px-6">
        <div className="w-full max-w-3xl text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Seekho Ad Management System
          </h1>
          <p className="text-lg text-gray-600 mb-4">
            Seekho AMS is the platform Seekho uses to manage advertising
            campaigns, track performance, and grow the business.
          </p>
          <p className="text-base text-gray-500 mb-10">
            Create and review ad requests, manage delivery and moderation,
            launch campaigns, and monitor results — all in one place.
          </p>
          <Link
            to="/login"
            className="inline-flex items-center px-7 py-3.5 rounded-xl text-white font-medium bg-gradient-to-r from-[#5E30BF] to-[#AF30BF] hover:shadow-lg hover:shadow-primaryPurple/30 hover:scale-[1.01] active:scale-[0.99] transition-all"
          >
            Sign in to continue
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full px-6 py-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm text-gray-400">
        <span>© {new Date().getFullYear()} Seekho</span>
        <a
          href="https://seekho.in/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primaryPurple transition-colors"
        >
          Privacy Policy
        </a>
        <a
          href="https://seekho.in/terms-and-conditions/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primaryPurple transition-colors"
        >
          Terms &amp; Conditions
        </a>
      </footer>
    </section>
  );
};

export default HomePage;
